var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "401px",
    height: "401px",
    enableBackground: "new 312.809 0 401 401",
    viewBox: "312.809 0 401 401",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.223 0 0 1.223 -467.5 -843.44)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 601.45,
    y: 653.07,
    width: 401,
    height: 401,
    fill: "#E4E6E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m802.38 908.08c-84.515 0-153.52 48.185-157.38 108.62h314.79c-3.87-60.44-72.9-108.62-157.41-108.62z",
    fill: "#AEB4B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m881.37 818.86c0 46.746-35.106 84.641-78.41 84.641s-78.41-37.895-78.41-84.641 35.106-84.641 78.41-84.641c43.31 0 78.41 37.9 78.41 84.64z",
    fill: "#AEB4B7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfil);
export default __webpack_public_path__ + "static/media/profil.09187e8f10599a1a473c71aaf8a053e0.svg";
export { ForwardRef as ReactComponent };